module.exports = __webpack_public_path__ + "img/8.5bc44da5.png";